import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CaseStudyHero from './components/CaseStudyHero';
import ProblemStatement from './components/ProblemStatement';
import UsersRoles from './components/UsersRoles';
import ProductScope from './components/ProductScope';
import UXStrategy from './components/UXStrategy';
import InformationArchitecture from './components/InformationArchitecture';
import DesignDecisions from './components/DesignDecisions';
import DesignSystem from './components/DesignSystem';
import Outcomes from './components/Outcomes';

export default function CaseStudy() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <CaseStudyHero />
      <ProblemStatement />
      <UsersRoles />
      <ProductScope />
      <UXStrategy />
      <InformationArchitecture />
      <DesignDecisions />
      <DesignSystem />
      <Outcomes />
      <Footer />
    </div>
  );
}